import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ReceiptContentBox = styled(Box)(({ theme }) => ({
  fontFamily: 'monospace',
  fontSize: '0.875rem',
}));

export const HeaderBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(3),
}));

export const SectionBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const ProductBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const FlexBetweenBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
});

export const CenteredBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
}));

export const SignatureBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const FooterBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginTop: theme.spacing(3),
}));
